export default __webpack_public_path__ + "static/media/SP_Icon.9b87e497.svg";